import root from'./_root.js';/** Built-in value references. */var _Symbol=root.Symbol;export default _Symbol;